module.exports = __webpack_public_path__ + "media/audio48.4e60079c.mp3";